export default "__VITE_ASSET__CPJlPG56__"